import React from "react";
import { RadialGauge } from 'canvas-gauges';
import moment from 'moment';
import PropTypes from 'prop-types';

const center = {
  display: 'table',
  margin: '0 auto'
};

export default class CapacityGauge extends React.Component {
  constructor(props) {
    super(props);
    this.redraw = this.redraw.bind(this);
    //this.animateGauges = this.animateGauges.bind(this);
  }

  redraw(props) {
    let start = moment(props.start).format('Do'); 
    let end = moment(props.end).format('Do'); 
    let units = `${start} - ${end}`;
    if(start === end){
      units = moment(props.start).format('MMM Do'); 
    }
    let value = props.capacity;
    let terminal = props.terminal;
    this.gauge = new RadialGauge({
      renderTo: this.el,
      width: 150,
      height: 150,
      units: units,

      minValue: 0,
      //startAngle: 90,
      //ticksAngle: 90,
      valueInt: 1,
      valueDec: 0,
      //valueBox: true,
      
      colorValueText: "#000",
      //colorValueBoxRect: "#fff",
      //colorValueBoxRectEnd: "#fff",
      colorValueBoxBackground: "#ccc", //1, 65, 111
      //colorValueBoxShadow: false,
      //colorValueTextShadow: false,
      //fontNumbers: "Helvetica",
      //fontTitle: "Helvetica",
      //fontUnits: "Helvetica",
      //fontValue: "Helvetica",
      //fontValueStyle: 'italic',
      //fontNumbersSize: 20,
      //fontNumbersStyle: 'italic',
      //fontNumbersWeight: 'bold',
      //fontTitleSize: 24,
      fontUnitsSize: 35,
      fontUnitWeight: 'bold',
      colorUnits: "#000",
      fontValueSize: 35,
      maxValue: 100,
      majorTicks: [
        "0",
        "10",
        "20",
        "30",
        "40",
        "50",
        "60",
        "70",
        "80",
        "90",
        "100"
      ],
      minorTicks: 3,
      strokeTicks: true,
      highlights: [
        {
          "from": 0,
          "to": 20,
          "color": "rgba(200, 50, 50, .75)"
        },
        {
          "from": 80,
          "to": 100,
          "color": "rgba(50, 200, 50, .75)"
        }
      ],
      colorPlate: "#fff",
      borderShadowWidth: 0,
      borders: false,
      needleType: "arrow",
      needleWidth: 6,
      needleCircleSize: 4,
      needleCircleOuter: true,
      needleCircleInner: true,
      //animatedValue: true,
      //animateOnInit:true,    
      //animationDuration: 250,
      //animationRule: "bounce",
      value: value
    }).draw();
  }
  componentWillReceiveProps(nextProps) {

    if ((this.props.capacity !== nextProps.capacity) ||
      (this.props.terminal !== nextProps.terminal)||
      (this.props.start !== nextProps.start)||
      (this.props.end !== nextProps.end)) {
      this.redraw(nextProps);
    }

  }

  componentDidMount() {
    this.redraw(this.props);
  }

  render() {
    return <div style={center}>
      <canvas
        ref={(canvas) => {
          this.el = canvas;
        }} />
    </div>;
  }
}

RadialGauge.propTypes = {
  capacity: PropTypes.number,
  terminal: PropTypes.string,
  start: PropTypes.objectOf(Date),
  end: PropTypes.objectOf(Date)
};







// WEBPACK FOOTER //
// ./src/components/CapacityGauge/CapacityGauge.js